<template>
    <!-- Navbar dropdowns -->
    <b-nav-item-dropdown text="Preprensa" v-show="isOK == true" left>
       
        <b-dropdown-item exact to="/home/listado-preprensa">Abiertas</b-dropdown-item>
        <b-dropdown-item exact to="/home/historico-preprensa">Cerradas</b-dropdown-item>
    </b-nav-item-dropdown>
</template>

<script>
   import {mapState,mapActions} from 'vuex'
    import customMixin from '@/mixins/customMixin'
    export default {
        mixins : [customMixin],
        data: function(){
            return {
                isOK: false
            }
        },
        mounted(){
            this.init()
        },
        computed:{
            ...mapState('login',['rol_id']),
            ...mapState('permiso',['permiso']), 
        },
        methods:{
            ...mapActions({
                _fetchPermisos: 'permiso/fetchPermisosUsuarios',
            }),
            init(){
                this._fetchPermisos(this.rol_id).then(() => {  
                    this.isOK =  this.isPreprensa(this.permiso) 
                })
            },
        }//end methods      
    }
</script>

<style lang="scss" scoped>

</style>